import filter from 'lodash/filter.js';
import get from 'lodash/get.js';
import map from 'lodash/map.js';

import axios from '@/plugins/axios.js';
import { promiseError } from '@/store/utilities/Helpers.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default {
    state: {
        activities: [],
        breaks: [],
        courses: [],
        selectedCourseIds: [],
        loading: false,
        cache: {
            startDate: null,
            endDate: null,
        },
    },

    getters: {
        courses(state) {
            return filter(state.courses, course => state.selectedCourseIds.includes(course.id));
        },

        courseIds(state, getters) {
            return getters.courses.length ? map(getters.courses, 'id').join(',') : '-1';
        },
    },

    actions: {
        initCourses({ commit }, courses) {
            commit('SET_COURSES', courses);
            commit('SET_SELECTED_COURSES', map(courses, 'id'));
        },

        async fetchActivities(context, dates) {
            const { commit, getters, state } = context;

            const startDate = get(dates, 'startDate', state.cache.startDate);
            const endDate = get(dates, 'endDate', state.cache.endDate);

            commit('CACHE_DATES', { startDate, endDate });

            commit('TOGGLE_LOADING');

            const queryBuilder = new QueryBuilder('activities');

            queryBuilder
                .filters([
                    { key: 'due_after', value: startDate },
                    { key: 'due_before', value: endDate },
                ])
                .include('course')
                .fields([{ key: 'course', value: 'id,title' }]);

            if (!!getters.courseIds && getters.courseIds !== '-1') {
                queryBuilder.filter('course_id', getters.courseIds);
            }

            try {
                const { data } = await axios.get(queryBuilder.toUrl());

                context.commit('SET_ACTIVITIES', data.data);

                return data.data;
            } catch (error) {
                promiseError({
                    key: 'activity_calendar_load_error',
                    context,
                });

                return error;
            } finally {
                commit('TOGGLE_LOADING');
            }
        },

        async fetchBreaks(context, dates) {
            const { commit, getters, state } = context;

            const startDate = get(dates, 'startDate', state.cache.startDate);
            const endDate = get(dates, 'endDate', state.cache.endDate);

            commit('CACHE_DATES', { startDate, endDate });

            commit('TOGGLE_LOADING');

            const queryBuilder = new QueryBuilder('sections');

            queryBuilder
                .filters([
                    { key: 'course_id', value: getters.courseIds },
                    { key: 'overlap_start', value: endDate },
                    { key: 'overlap_end', value: startDate },
                    { key: 'sectionSettings.type', value: 'break' },
                ])
                .include(['course', 'sectionSettings'])
                .fields([{ key: 'course', value: 'id,title' }]);

            try {
                const { data } = await axios.get(queryBuilder.toUrl());

                context.commit('SET_BREAKS', data.data);

                return data.data;
            } catch (error) {
                promiseError({
                    key: 'activity_calendar_load_error',
                    context,
                });

                return error;
            } finally {
                commit('TOGGLE_LOADING');
            }
        },
    },

    mutations: {
        SET_COURSES(state, courses) {
            state.courses = courses;
        },

        SET_SELECTED_COURSES(state, courseIds) {
            state.selectedCourseIds = courseIds;
        },

        SET_ACTIVITIES(state, activities) {
            state.activities = activities;
        },

        SET_BREAKS(state, breaks) {
            state.breaks = breaks;
        },

        TOGGLE_LOADING(state) {
            state.loading = !state.loading;
        },

        CACHE_DATES(state, dates) {
            state.cache = dates;
        },
    },
};
